module.exports = __webpack_public_path__ + "img/K6403293.fce38d3c.jpg";